import axios from "axios";
import { VALAQUENTA_API_URL } from "..";

export function queryAttractorLogs({ payload }) {
  return axios.post(`${VALAQUENTA_API_URL}/elasticattractor/query`, payload);
}
